export const homeBackgroundColor = "#F5F5F5";

// link for these color names and codes: https://mui.com/material-ui/customization/palette/
export const stateInitialColor = "#ffb74d"; // mui theme.palette.warning.light
export const stateFinalColor = "#81c784"; // mui theme.palette.success.light;
export const stateInitialFinalColor = "#4fc3f7"; // mui theme.palette.info.light

export const stateHoverColor = "rgb(230, 230, 230)";
export const stateSelectedColor = "rgb(200, 200, 200)";
export const stateOperationColor = "LemonChiffon";

export const transitionColor = "coral";
export const transitionHoverColor = "IndianRed";
export const transitionSelectedColor = "black";

export const startingStateColor = "lightblue"; // pink tone

export const appBarBackgroundColor = "rgba(148, 148, 148, 0.15)";
export const drawerHeaderBoxShadow =
  "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)";
